import { StylesConfig } from "react-select";

// Interface
export interface ColourOption {
  readonly value: string;
  readonly label: string;
  readonly color: string;
  readonly isFixed?: boolean;
  readonly isDisabled?: boolean;
}

const selectStyle: StylesConfig<ColourOption> = {
  indicatorsContainer: (p: any, state: any) => ({
    ...p,
    boxShadow: "none",
    borderColor: "none",
    transition: "all .2s ease",
    transform: state.selectProps.menuIsOpen ? "rotate(180deg)" : "rotate(0deg)"
  }),
  dropdownIndicator: (p: any) => ({
    ...p,
    color: "#2F3533"
  }),
  clearIndicator: (p: any) => ({
    ...p,
    cursor: "pointer"
  }),
  valueContainer: (p: any) => ({
    ...p,
    "&:hover, &:focus": {
      boxShadow: "none",
      borderColor: "none"
    },
    color: "#060606",
    fontWeight: "500",
    fontSize: "1.4rem",
    fontStyle: "normal",
    lineHeight: "2.4rem",
    letterSpacing: "0.8px",
    fontFamily: "Poppins",

    "@media only screen and (max-width: 1024px)": {
      ...p["@media only screen and (max-width: 1024px)"],
      maxWidth: "100%"
    }
  }),
  menu: (p: any) => ({
    ...p,
    "&:hover, &:focus, &:active": {
      boxShadow: "none",
      borderColor: "unset",
      backgroundColor: "#fff"
    },

    color: "#060606",
    fontWeight: "500",
    fontSize: "1.4rem",
    fontStyle: "normal",
    lineHeight: "2.4rem",
    letterSpacing: "0.8px",
    backgroundColor: "#fff",
    fontFamily: "Poppins"
  }),
  option: (p: any) => ({
    ...p,
    "&:hover, &:focus, &:active": {
      boxShadow: "none",
      borderColor: "none",
      backgroundColor: "#F2F2F2"
    },

    margin: "0 auto",
    borderRadius: "4px",
    padding: "10px 8px",
    width: "calc(100% - 8px)",

    color: "#060606",
    fontWeight: "500",
    cursor: "pointer",
    fontSize: "1.4rem",
    fontStyle: "normal",
    lineHeight: "2.4rem",
    letterSpacing: "0.8px",
    fontFamily: "Poppins",
    backgroundColor: "transparent"
  }),
  container: (p: any) => ({
    ...p,
    "&:hover, &:focus": {
      boxShadow: "none",
      borderColor: "none"
    },
    width: "100%",
    height: "4.4rem",
    color: "#060606",
    maxWidth: "40rem",
    fontWeight: "500",
    fontSize: "1.4rem",
    fontStyle: "normal",
    minHeight: "4.4rem",
    lineHeight: "2.4rem",
    letterSpacing: "0.8px",
    fontFamily: "Poppins",

    "@media only screen and (max-width: 1024px)": {
      ...p["@media only screen and (max-width: 1024px)"],
      maxWidth: "100%"
    }
  }),
  control: (p: any) => ({
    ...p,
    "&:hover, &:focus": {
      boxShadow: "none",
      borderColor: "unset"
    },
    width: "100%",
    border: "unset",
    height: "4.4rem",
    minHeight: "4.4rem",
    color: "#060606",
    boxShadow: "none",
    maxWidth: "40rem",
    cursor: "pointer",
    fontWeight: "500",
    fontSize: "1.4rem",
    fontStyle: "normal",
    borderStyle: "unset",
    lineHeight: "2.4rem",
    borderRadius: "unset",
    letterSpacing: "0.8px",
    fontFamily: "Poppins",
    backgroundColor: "transparent",
    borderBottom: "1px solid rgba(6, 6, 6, 0.25)",

    "@media only screen and (max-width: 1024px)": {
      ...p["@media only screen and (max-width: 1024px)"],
      maxWidth: "100%"
    }
  }),
  placeholder: (p: any) => ({
    ...p,
    outline: "none",
    "&:hover, &:focus": {
      boxShadow: "none",
      borderColor: "none"
    },
    color: "#9B9B9B",
    fontWeight: "400",
    fontSize: "1.4rem",
    paddingLeft: "0px",
    fontStyle: "normal",
    lineHeight: "2.4rem",
    letterSpacing: "0.8px",
    fontFamily: "Poppins",
    backgroundColor: "transparent"
  }),
  indicatorSeparator: (p: any) => ({
    ...p,
    width: 0,
    marginRight: "2px"
  })
};

const styleFieldSelectSize = {
  ...selectStyle,
  valueContainer: (provided: any) => ({
    ...provided,
    "&:hover, &:focus": {
      boxShadow: "none",
      borderColor: "none"
    },
    color: "#FFF"
  }),
  singleValue: (p: any) => ({
    ...p,
    color: "#FFF"
  }),
  input: (p: any) => ({
    ...p,
    color: "#FFF"
  }),
  container: (provided: any) => ({
    ...provided,
    "&:hover, &:focus": {
      color: "#FFF"
    },
    height: "4rem",
    width: "8rem",
    color: "#FFF",
    maxWidth: "100%",
    fontWeight: "500",
    fontSize: "1.4rem",
    fontStyle: "normal",
    lineHeight: "1.8rem",
    letterSpacing: "0.8px",
    fontFamily: "Poppins",

    "@media only screen and (max-width: 1024px)": {
      ...provided["@media only screen and (max-width: 1024px)"],
      maxWidth: "100%"
    }
  }),
  value: (p: any) => ({
    ...p,
    lineHeight: "1.8rem"
  }),
  placeholder: (provided: any) => ({
    ...provided,
    color: "#FFF",
    fontWeight: "400",
    fontSize: "1.4rem",
    fontStyle: "normal",
    lineHeight: "1.8rem",
    letterSpacing: "0.8px",
    fontFamily: "Poppins"
  }),
  menu: (provided: any) => ({
    ...provided,
    zIndex: 9999,
    "&:hover, &:focus": {
      color: "#FFF"
    }
  }),
  control: (provided: any) => ({
    ...provided,
    "&:hover, &:focus": {
      color: "#FFF",
      borderColor: "unset"
    },
    width: "8rem",
    height: "4rem",
    border: "unset",
    color: "#FFF",
    boxShadow: "none",
    maxWidth: "100%",
    cursor: "pointer",
    fontWeight: "500",
    fontSize: "1.4rem",
    fontStyle: "normal",
    borderStyle: "unset",
    lineHeight: "1.8rem",
    borderRadius: "unset",
    letterSpacing: "0.8px",
    fontFamily: "Poppins",
    backgroundColor: "transparent",
    borderBottom: "1px solid #fff",

    "@media only screen and (max-width: 1024px)": {
      ...provided["@media only screen and (max-width: 1024px)"],
      maxWidth: "100%"
    }
  })
};

export {
  selectStyle,
  styleFieldSelectSize
};
